// utils/importIcons.js
function importAll(r) {
  let icons = {};
  r.keys().forEach((key) => {
    const name = key.replace("./", "").replace(/\.(png|jpe?g|svg)$/, "");
    icons[name] = r(key);
  });

  return icons;
}

export const icons = importAll(require.context("../Images/weather", false, /\.(png|jpe?g|svg)$/));
